<template>
    <svg :class="className" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.3398 5.68457C10.3398 3.11372 8.25544 1.0293 5.68457 1.0293C3.11373 1.02933 1.02933 3.11373 1.0293 5.68457C1.0293 8.25544 3.11372 10.3398 5.68457 10.3398C8.25546 10.3398 10.3398 8.25546 10.3398 5.68457ZM11.3701 5.68457C11.3701 8.82431 8.82431 11.3701 5.68457 11.3701C2.54485 11.3701 0 8.82428 0 5.68457C3.29882e-05 2.54488 2.54488 3.29872e-05 5.68457 0C8.82428 0 11.3701 2.54485 11.3701 5.68457Z"/>
        <path d="M7.24463 1.03467L2.84467 6.20465H5.43463L4.14465 10.3447L8.54468 5.17468H5.95465L7.24463 1.03467Z"/>
    </svg>
</template>

<script>
export default {
    name: 'IconCharger',

    props: {
        className: String
    }
};
</script>
